<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Filter
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="mb-3">
                        <label class="control-label">User Story Tag</label>
                        <multiselect
                            v-model="tagsSelected"
                            :options="tags"
                            :multiple="true"
                            @search-change="searchTags"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :hideSelected="true"
                            placeholder=""
                            :showLabels="false"
                            label="text"
                            track-by="id"
                            name="tags">
                        </multiselect>
                    </div><!-- /.form-group -->

                    <div class="mb-3">
                        <label class="control-label">Costing Group</label>
                        <multiselect
                            v-model="groupsSelected"
                            :options="groups"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :hideSelected="true"
                            placeholder=""
                            :showLabels="false"
                            label="text"
                            track-by="id"
                            name="groups">
                            <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options selected</span>
                            </template> -->
                        </multiselect>
                    </div><!-- /.form-group -->

                    <div class="mb-3">
                        <label class="control-label">Estimation</label>
                        <multiselect
                            v-model="estimationOption"
                            :options="estimationOptions"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="false"
                            :allow-empty="false"
                            :showLabels="false"
                            placeholder=""
                            name="estimation">
                            <!-- <template slot="selection" slot-scope="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options selected</span>
                            </template> -->
                        </multiselect>
                        <p v-if="missingEstimates" class="form-text">{{ missingEstimates }} Missing Estimates</p>
                    </div><!-- /.form-group -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import { Selectize, LaddaButton } from 'components/form/input'
    import Multiselect from 'vue-multiselect'
    import { SET_PROPERTY } from 'vx/mutations'
    import { debounce } from 'lodash'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            LaddaButton,
            Multiselect
        },

        data() {
            return {
                estimationOptions: [
                    'Any',
                    'Missing Estimate',
                    'Estimated'
                ]
            }
        },

        computed: {
            ...mapState('groups', ['groups']),
            ...mapState('tags', ['tags']),
            ...mapState('epics', ['epics']),
            ...mapState('settings/userstories', ['filters']),

            tagsSelected: {
                get () {
                    return this.filters.selectedTags
                },

                set (value) {
                    this[SET_PROPERTY]({ property: 'filters.selectedTags', value: value })
                }
            },

            groupsSelected: {
                get () {
                    return this.filters.selectedGroups
                },

                set (value) {
                    this[SET_PROPERTY]({ property: 'filters.selectedGroups', value: value })
                }
            },

            estimationOption: {
                get () {
                    return this.filters.estimation
                },

                set (value) {
                    this[SET_PROPERTY]({ property: 'filters.estimation', value: value })
                }
            },

            missingEstimates () {
                var count = 0;

                this.epics.forEach(function(epic) {
                    count += epic.stories.filter(function(item) {
                        return item.estimate == null
                    }).length
                })

                return count;
            },
        },

        methods: {
            ...mapMutations('settings/userstories', [SET_PROPERTY]),
            ...mapActions('tags', ['getTagsList']),

            searchTags: debounce(async function (search) {
                await this.getTagsList({ text: search })
            }, 1250),
        }
    }
</script>